import { render, staticRenderFns } from "./formelement_textarea.vue?vue&type=template&id=8bb421e4&"
import script from "./formelement_textarea.vue?vue&type=script&lang=js&"
export * from "./formelement_textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports